import React from "react";

const Button = (props) => {
  const {
    titleButton,
    textColor,
    margin,
    width,
    backgroundColor,
    borderColor,
    padding = "py-1",
    disabled,
    onClick,
    fontWeight
  } = props;
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`${textColor} ${margin} ${width} ${backgroundColor} ${borderColor} ${fontWeight} border rounded-[4px] ${padding} `}
    >
      {titleButton}
    </button>
  );
};

export default Button;
